const ssoUserManagementPermission = "SsoUserManagement";
const socialFeedPermission = "SocialFeed";
const socialOrganizationGroupPermission = "SocialOrganizationGroup";
const socialCreateOrganizationGroupPermission = "SocialCreateOrganizationGroup"
const socialJoinOrganizationGroupPermission = "SocialJoinOrganizationGroup"
const socialGeneralGroupPermission = "SocialGeneralGroup";
const googleMeetPermission = "GoogleMeet";
const googleClassroomPermission = "GoogleClassroom";
const googleNotebookLMPermission = "GoogleNotebookLM";
const skillLanePermission = "SkillLane";
const moocDashboardPermission = "MoocDashboard";
const moocCoursePermission = "MoocCourse";
const moocCourseManagementPermission = "MoocCourseManagement";
const portfolioPermission = "Portfolio";
const teachingHubFeedPermission = "TeachingHubFeed";
const teachingHubCreateFeedPermission = "TeachingHubCreateFeed";
const aiPermission = "AI";
const schoolInformationPermission = "SchoolInformation";

const permissions = {
    guest: [socialFeedPermission,
        socialOrganizationGroupPermission,
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission,
        portfolioPermission,
        aiPermission],
    admin: [socialFeedPermission, 
        socialOrganizationGroupPermission,
        socialJoinOrganizationGroupPermission,
        socialCreateOrganizationGroupPermission,   
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission,
        moocCourseManagementPermission,
        portfolioPermission,
        teachingHubFeedPermission,
        aiPermission,
        schoolInformationPermission],
    teacher: [socialFeedPermission, 
        socialOrganizationGroupPermission,
        socialJoinOrganizationGroupPermission, 
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission,
        moocCourseManagementPermission,
        portfolioPermission,
        teachingHubFeedPermission,
        aiPermission,
        schoolInformationPermission],
    case_manager: [socialFeedPermission, 
        socialOrganizationGroupPermission,
        socialJoinOrganizationGroupPermission,  
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission,
        portfolioPermission,
        teachingHubFeedPermission,
        aiPermission],
    curriculum: [socialFeedPermission, 
        socialOrganizationGroupPermission,
        socialJoinOrganizationGroupPermission, 
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission,
        moocCourseManagementPermission,
        portfolioPermission,
        teachingHubFeedPermission,
        teachingHubCreateFeedPermission,
        aiPermission],
    psychologist: [socialFeedPermission, 
        socialOrganizationGroupPermission,
        socialJoinOrganizationGroupPermission,
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission,
        moocCourseManagementPermission,
        portfolioPermission,
        teachingHubFeedPermission,
        teachingHubCreateFeedPermission,
        aiPermission],
    student: [socialFeedPermission, 
        socialOrganizationGroupPermission, 
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission,
        portfolioPermission,
        aiPermission],
    admin_system: [ssoUserManagementPermission,
        socialFeedPermission, 
        socialOrganizationGroupPermission,
        socialCreateOrganizationGroupPermission,  
        socialGeneralGroupPermission, 
        googleMeetPermission, 
        googleClassroomPermission,
        googleNotebookLMPermission,
        skillLanePermission,
        moocDashboardPermission, 
        moocCoursePermission, 
        moocCourseManagementPermission,
        portfolioPermission,
        teachingHubFeedPermission,
        teachingHubCreateFeedPermission,
        aiPermission,
        schoolInformationPermission]
};

const getRoleFromSSO = (roleID) => {
    switch (roleID) {
        case "1":
            return "guest"
        case "4":
            return "admin"
        case "3":
            return "teacher"
        case "6":
            return "case_manager"
        case "7":
            return "curriculum"
        case "8":
            return "psychologist"
        case "2":
            return "student"
        case "5":
            return "admin_system"
        default:
            return ""
    }
}

const isGuest = (roleID) => {
    return roleID === "guest";
}

const IsStudent = (roleID) => {
    return roleID === "student"
}

const filterIsTeacher = (roleID) => {
    return roleID === "teacher" || roleID === "admin_system";
};

const filterIsStudent = (roleID) => {
    return roleID === "student" || roleID === "admin_system";
};

const isAdmin = (roleID) => {
    return roleID === "admin" || roleID === "admin_system";
};

const isAdminSys = (roleID) => {
    return roleID === "admin_system";
};

const getRoleFromSocial = (roleID) => {
    return roleID;
}

const getRoleFromMooc = (roleID) => {
    switch (roleID) {
        case "11":
            return "guest"
        case "7":
            return "admin"
        case "4":
            return "teacher"
        case "8":
            return "case_manager"
        case "9":
            return "curriculum"
        case "10":
            return "psychologist"
        case "3":
            return "student"
        case "1":
            return "admin_system"
        default:
            return ""
    }
}

const getRoleFromPortfolio = (roleID) => {
    switch (roleID) {
        case "4":
            return "guest"
        case "1":
            return "admin"
        case "3":
            return "teacher"
        case "6":
            return "case_manager"
        case "7":
            return "curriculum"
        case "8":
            return "psychologist"
        case "2":
            return "student"
        case "5":
            return "admin_system"
        default:
            return ""
    }
}

const createRoleAccess = (userRole) => {
    const hasAccess = (appName) => {
        const allowedApps = permissions[userRole] || [];
        return allowedApps.includes(appName);
    };

    return {
        canViewSsoUserManagement: () => hasAccess(ssoUserManagementPermission),
        canViewSocialFeed: () => hasAccess(socialFeedPermission),
        canViewSocialOrganizationGroup: () => hasAccess(socialOrganizationGroupPermission),
        canCreateSocialOrganizationGroup: () => hasAccess(socialCreateOrganizationGroupPermission),
        canJoinSocialOrganizationGroup: () => hasAccess(socialJoinOrganizationGroupPermission),
        canViewSocialGeneralGroup: () => hasAccess(socialGeneralGroupPermission),
        canViewGoogleMeet: () => hasAccess(googleMeetPermission),
        canViewGoogleClassroom: () => hasAccess(googleClassroomPermission),
        canViewGoogleNotebookLM: () => hasAccess(googleNotebookLMPermission),
        canViewSkillLane: () => hasAccess(skillLanePermission),
        canViewMoocDashboard: () => hasAccess(moocDashboardPermission),
        canViewMoocCourse: () => hasAccess(moocCoursePermission),
        canViewMoocCourseManagement: () => hasAccess(moocCourseManagementPermission),
        canViewPortfolio: () => hasAccess(portfolioPermission),
        canViewTeachingHubFeed: () => hasAccess(teachingHubFeedPermission),
        canViewTeachingHubCreateFeed: () => hasAccess(teachingHubCreateFeedPermission),
        canViewAI: () => hasAccess(aiPermission),
        canViewSchoolInformation: () => hasAccess(schoolInformationPermission),
    };
};

export default createRoleAccess;
export {getRoleFromSSO,getRoleFromMooc,getRoleFromPortfolio,getRoleFromSocial,filterIsStudent,filterIsTeacher,isGuest,IsStudent,isAdmin,isAdminSys};
